import { SVG, SVGProps } from './svg'

export function IconTrendingDown(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M21.5 19h-5a.5.5 0 0 1-.5-.5v-.29a.49.49 0 0 1 .15-.36l1.64-1.64-4.29-4.3-2.65 2.65a.48.48 0 0 1-.7 0l-8-8a.5.5 0 0 1 0-.71l.7-.7a.5.5 0 0 1 .71 0l6.94 6.94 2.65-2.65a.48.48 0 0 1 .7 0l5.36 5.35 1.64-1.64a.49.49 0 0 1 .36-.15h.29a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5Z" />
    </SVG>
  )
}
